import React from 'react';
import ActionPlan from '@lifeomic/phc-web-toolkit/src/components/SubjectViewer/Modules/ActionPlan';
import { ModuleType } from '@lifeomic/phc-web-toolkit/src/components/SubjectViewer/Modules/basicModuleTypesConfig';
import {
  DashboardConfig,
  ModuleConfig,
} from '@lifeomic/phc-web-toolkit/src/components/LayoutConfiguration/types';
import MemberDetail from './index';

const actionPlanModuleConfig: ModuleConfig<{ displayAsDuration: boolean }> = {
  version: 1,
  module: {
    key: 'member-action-plan',
    moduleType: ModuleType.ActionPlan,
    title: 'Action Plan',
    layout: {
      w: 12,
      h: 20,
      minW: 1,
      minH: 1,
      x: 0,
      y: 0,
      isResizable: true,
    },
  },
  component: { displayAsDuration: false },
};

const actionPlanDashboardConfig: DashboardConfig = {
  version: 1,
  modules: [actionPlanModuleConfig],
};

const actionPlanInjectedPropsBase = {
  moduleKey: actionPlanModuleConfig.module.key,
  isModuleVisible: true,
  dateTickFilter: { min: 0, max: 0 },
  dateTickBounds: { min: 0, max: 0 },
  dateFilter: { min: new Date(0), max: new Date() },
  isInEditMode: false,
  deviceId: 'member-detail',
  moduleConfig: actionPlanModuleConfig,
  onModuleConfigChange: () => undefined,
  onDynamicDataResolved: () => ({}),
  selectedDashboardConfig: actionPlanDashboardConfig,
} as const;

type ActionPlanContentProps = {
  member: fhir.Patient | null;
  memberId: string;
  fallback: React.ReactNode;
};

export const ActionPlanContent: React.FC<ActionPlanContentProps> = ({
  member,
  memberId,
  fallback,
}) => {
  if (!member) {
    return <>{fallback}</>;
  }

  return (
    <ActionPlan
      {...actionPlanInjectedPropsBase}
      patient={{
        ...member,
        id: member.id || memberId,
      }}
    />
  );
};

const MemberActionPlan: React.FC = () => {
  return <MemberDetail section="action-plan" />;
};

MemberActionPlan.displayName = 'MemberActionPlan';
export default MemberActionPlan;
